"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _PropertyValidations = require("customer-data-properties/validation/PropertyValidations");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var propTypes = {
  value: _react.PropTypes.string.isRequired
};
var defaultProps = {
  value: ''
};

var PropertyInputFiles =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputFiles, _React$Component);

  function PropertyInputFiles() {
    (0, _classCallCheck2.default)(this, PropertyInputFiles);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputFiles).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyInputFiles, [{
    key: "getValue",
    value: function getValue() {
      var urls = this.props.value ? this.props.value.split(/[;,]+/) : [];
      return urls.filter(function (url) {
        return (0, _PropertyValidations.isValidDomain)(url.trim());
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIList.default, {
        className: "p-top-2"
      }, this.getValue().map(function (url) {
        var fileName = url.match(/\/([^/]*)$/)[1];
        return _react.default.createElement(_UILink.default, {
          key: url,
          href: url,
          external: true
        }, ' ', fileName, ' ');
      }));
    }
  }]);
  return PropertyInputFiles;
}(_react.default.Component);

exports.default = PropertyInputFiles;
PropertyInputFiles.propTypes = propTypes;
PropertyInputFiles.defaultProps = defaultProps;
module.exports = exports.default;